import "core-js/modules/es6.regexp.replace";
var rHyphen = /-(.)/g;
export default function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}